class FileListController {
    constructor(_) {
        this._ = _;       
    }

    onFileFetched(fileDto) {
        this.onFileFetch({ fileDto: fileDto});
    }

    truncate(fileName) {      
        let fileNameParts = fileName.split(".");
        let fileExtension = fileNameParts.pop();
        let nameExcludingExtension = fileNameParts.join('');
   
        return this._.truncate(nameExcludingExtension, { 'length': 24, 'separator': ' ', 'omission': ' [...]' }).concat(".", fileExtension);
    }
    onFileDeleted(fileDto) {
        this.onFileDelete({ fileDto: fileDto });
    }
}

export default {
    controller: FileListController,
    bindings: {      
        readonly: '<',      
        fileList: '<',
        onFileFetch: '&',
        onFileDelete: '&'
    },
    templateUrl: `app/components/file-list/file-list.html`
};

FileListController.$inject = ['_']


// WEBPACK FOOTER //
// ./app/components/file-list/file-list.component.js